export default __webpack_public_path__ + "static/media/ens-monthly-roundup-march-2023.82657864.md";